import React from 'react';

interface IDPlansLogoProps {
    width?: number | string;
    height?: number | string;
    className?: string;
}

/**
 * ID Plans logo as a React SVG component.
 * Default size matches the original SVG (134x37).
 */
const IDPlansLogo: React.FC<IDPlansLogoProps> = ({ width = 134, height = 37, className }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 134 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M6.99345 16.4925V9.74902H0.25V16.4925H6.99345Z"
            fill="#00ADEF"
            stroke="#00ADEF"
            strokeWidth="0.5"
        />
        <path
            d="M6.99345 36.7228V19.5559H0.25V36.7228H6.99345Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
        />
        <path
            d="M51.8477 29.4013V16.8007H61.6931C63.3115 16.8007 64.0051 16.8585 64.5831 17.0511C66.1438 17.5135 66.7025 18.5732 66.7025 21.1165C66.7025 23.0432 66.3942 24.1029 65.6236 24.7579C64.9685 25.3359 64.0051 25.5479 62.0399 25.5479H54.757V29.4013H51.8477ZM54.7377 23.1973H61.2114C63.2344 23.1973 63.7547 22.7927 63.7547 21.2513C63.7547 19.5558 63.273 19.132 61.3463 19.132H54.7377V23.1973ZM68.2439 29.4013V16.8007H71.1532V27.0314H80.3435V29.382H68.2439V29.4013ZM94.3892 26.8966H85.3915L83.985 29.382H80.7096L87.9155 16.7814H91.8652L98.9555 29.382H95.7764L94.3892 26.8966ZM93.3102 24.8543L89.9 18.8237L86.509 24.8543H93.3102ZM99.4564 29.4013V16.8007H103.965L113.425 27.2819L113.367 16.8007H116.142V29.4013H111.614L102.212 18.9778L102.269 29.4013H99.4564ZM118.068 25.413H120.92V25.5479C120.92 26.3571 121.074 26.8002 121.421 26.9929C121.883 27.2626 122.847 27.3782 124.715 27.3782C126.276 27.3782 127.259 27.3204 128.607 27.147C129.339 27.0507 129.706 26.9158 129.937 26.6654C130.187 26.3571 130.322 25.991 130.322 25.5864C130.322 24.8543 129.995 24.5075 129.108 24.2955C128.627 24.1799 128.627 24.1799 125.12 24.1607H123.328C120.746 24.1607 119.629 23.9294 118.916 23.2936C118.338 22.7734 118.049 21.9642 118.049 20.866C118.049 19.4595 118.396 18.3228 118.974 17.7833C119.841 16.9933 121.768 16.6851 125.929 16.6851C129.224 16.6851 130.457 16.8392 131.517 17.3787C132.403 17.8411 132.75 18.6696 132.788 20.5385H129.956C129.937 19.8063 129.763 19.421 129.378 19.2283C128.858 18.9778 127.644 18.8237 126.238 18.8237C123.868 18.8237 122.191 18.9778 121.633 19.2668C121.17 19.4788 120.958 19.9026 120.958 20.4999C120.958 21.0394 121.132 21.4055 121.479 21.6174C121.922 21.8679 122.635 21.9449 124.6 21.9449H126.758C130.534 21.9449 131.69 22.1569 132.48 23.0046C133 23.5441 133.251 24.3919 133.251 25.6249C133.251 26.9544 132.962 27.8599 132.345 28.4572C131.517 29.2471 129.898 29.5169 125.64 29.5169C121.112 29.5169 119.687 29.3049 118.897 28.5535C118.338 28.0333 118.088 27.2434 118.088 26.0681C118.049 25.9139 118.049 25.6635 118.068 25.413Z"
            fill="black"
        />
        <path d="M41.1543 36.7228V9.74902" stroke="black" strokeOpacity="0.5" strokeWidth="2.5" />
        <path
            d="M10.0762 16.4925V9.74902H27.2431C33.1195 9.74902 34.1984 14.2382 33.9865 16.4925V29.9794C33.9865 35.3741 29.4973 36.7228 27.2431 36.7228H10.0762V29.9794H27.2431V16.4925H10.0762Z"
            fill="black"
            stroke="black"
            strokeWidth="0.5"
        />
        <path d="M23.9869 19.6909H21.4629V22.2149H23.9869V19.6909Z" fill="#00ADEF" />
        <path d="M28.63 13.4482H23.582V18.4962H28.63V13.4482Z" fill="#4068CF" />
        <path d="M31.1534 21.791H26.1055V26.839H31.1534V21.791Z" fill="#EF4323" />
        <path d="M38.4185 11.8491H35.8945V14.3731H38.4185V11.8491Z" fill="#00ADEF" />
        <path d="M39.6317 1.27173H34.5645V6.33895H39.6317V1.27173Z" fill="#C61A89" />
        <path d="M43.3501 0H40.8262V2.52398H43.3501V0Z" fill="#00ADEF" />
        <path d="M32.0203 5.74146H26.9531V10.8087H32.0203V5.74146Z" fill="#9FCC3E" />
        <path d="M26.106 4.48926H23.582V7.01323H26.106V4.48926Z" fill="#00ADEF" />
        <path d="M37.1082 15.4714H32.041V20.5194H37.1082V15.4714Z" fill="#54C4C6" />
    </svg>
);

export default IDPlansLogo;
